export const normalizeCurrency = (value: string | null | undefined, fallback = "0,00") => {
    const v = value ?? fallback;
    const str = v.toString();
    return str.includes(",") ? str : `${str},00`;
};